import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import theme from './helpers/theme';
import keycloak from './helpers/keycloak';

try {
  // Disabled: relies on a third-party iframe cookie that modern browsers block by default,
  // causing false "session changed" detections and a refresh loop every checkLoginIframeInterval (5s).
  await keycloak.init({onLoad: "login-required", checkLoginIframe: false});
} catch (error) {
  console.error('Failed to initialize adapter:', error);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App auth={keycloak} />
    </ThemeProvider>
  </React.StrictMode>
);